import { Component, inject, OnInit } from "@angular/core";
import { CommonModule } from "@angular/common";
import { PiezeoDashboardService } from "../../../../../app/services/piezo-dashboard.service";
import { ConvertDatetimePipe } from "../../../../../app/convert-datetime.pipe";

interface Alert {
  type: string;
  timestamp: string;
  status: "critical" | "warning" | "resolved";
}

@Component({
  selector: "app-piezo-alerts",
  templateUrl: "./piezo-alerts.component.html",
  styleUrl: "./piezo-alerts.component.scss",
  standalone: true,
  imports: [CommonModule],
})
export class PiezoAlerts implements OnInit {
  piezo_srv = inject(PiezeoDashboardService);

  piezo_asset_ids: number[] = [];
  emsaver_asset_ids: number[] = [];
  client_id = "";

  alerts: Alert[] = [];
  isLoading = true;
  private loadingStates = {
    piezo: false,
    emsaver: false
  };

  constructor() {}

  ngOnInit() {
    const { device_position, client_id } = this.piezo_srv.getSubsystemData();

    const parsed = JSON.parse(device_position);

    this.piezo_asset_ids = parsed
      .filter((s) => s.master_type == 4)
      .map((s) => s.asset_id);
    this.emsaver_asset_ids = parsed
      .filter((s) => s.master_type != 4)
      .map((s) => s.asset_id);

    this.client_id = client_id;

    // Fetch both alerts
    this.fetchPiezoAlerts();
    this.fetchEmsaverAlerts();
  }

  private checkLoadingComplete() {
    if (this.loadingStates.piezo && this.loadingStates.emsaver) {
      this.isLoading = false;
    }
  }

  fetchPiezoAlerts() {
    try {
      if (this.piezo_asset_ids.length === 0) {
        console.warn("No Piezo asset IDs found.");
        this.loadingStates.piezo = true;
        this.checkLoadingComplete();
        return;
      }

      const assetIdsString = this.piezo_asset_ids.join(",");

      this.piezo_srv
        .fetchPiezoAlerts(this.client_id, assetIdsString)
        .then((res: any[]) => {
          if (Array.isArray(res) && res.length > 0) {
            const piezoAlerts = res.map((alert) => ({
              type: alert.error || "Alert Detected",
              timestamp: new ConvertDatetimePipe().convertDateTime(alert.time),
              status: "critical" as const
            }));

            this.alerts = [...this.alerts, ...piezoAlerts];
          }
        })
        .catch((err) => {
          console.error("Fetch Piezo Alerts Error:", err);
        })
        .finally(() => {
          this.loadingStates.piezo = true;
          this.checkLoadingComplete();
        });
    } catch (error) {
      console.error("fetchPiezoAlerts() Exception:", error);
      this.loadingStates.piezo = true;
      this.checkLoadingComplete();
    }
  }

  fetchEmsaverAlerts() {
    try {
      if (this.emsaver_asset_ids.length === 0) {
        console.warn("No Emsaver asset IDs found.");
        this.loadingStates.emsaver = true;
        this.checkLoadingComplete();
        return;
      }

      const assetIdsString = this.emsaver_asset_ids.join(",");

      this.piezo_srv
        .fetchPiezoAlerts(this.client_id, assetIdsString)
        .then((res: any[]) => {
          if (Array.isArray(res) && res.length > 0) {
            const emsaverAlerts = res.map((alert) => ({
              type: alert.error || "Alert Detected",
              timestamp: new ConvertDatetimePipe().convertDateTime(alert.time),
              status: "critical" as const
            }));

            this.alerts = [...this.alerts, ...emsaverAlerts];
          }
        })
        .catch((err) => {
          console.error("Fetch Emsaver Alerts Error:", err);
        })
        .finally(() => {
          this.loadingStates.emsaver = true;
          this.checkLoadingComplete();
        });
    } catch (error) {
      console.error("fetchEmsaverAlerts() Exception:", error);
      this.loadingStates.emsaver = true;
      this.checkLoadingComplete();
    }
  }
}